// src/components/organisms/WeatherDetailDisplay.js
import React, { useEffect, useState } from 'react';
import Badge from '../molecules/Badge';
import Clock from '../atom/Clock';
import './WeatherDetailDisplay.css';

const WeatherDetailDisplay = ({ data }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);

    // Clean up on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!data) return <p>Wetterdaten werden geladen...</p>;

  return (
    <div>
      {/* 👇 Clock außerhalb von .weather-detail-display */}
      {!isMobile && (
        <div className='clock'>
          <Clock timeString={data.localtimeFull} />
        </div>
      )}

      <div className="weather-detail-display">
        {!isMobile && (
          <h2 className="city-name">{data.city}</h2>
        )}

        <div className="badge-grid">
          <Badge iconName="sunrise" textValue={data.forecastToday.sunrise} />
          <Badge iconName="sunset" textValue={data.forecastToday.sunset} />
          <Badge iconName="windTurbine" textValue={data.weatherDetails.wind_kph + " km/h"} />
          <Badge iconName="humidity" textValue={data.weatherDetails.humidity + "%"} />
          <Badge iconName="uvIndex" textValue={data.weatherDetails.uv} />
          <Badge
            iconName={data.forecastToday.moonPhaseIcon}
            textValue={data.forecastToday.moonPhaseName}
            iconType="moon"
          />
        </div>
      </div>
    </div>
  );
};

export default WeatherDetailDisplay;
